import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { useLocation } from "react-router-dom";
import { useAppConfig } from '../../AppConfigProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../ModernTable.css';

const DocumentsUp = ({ setLoad, load, vname }) => {
  const appConfig = useAppConfig();


  const [docs, setDocs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [docsPerPage] = useState(10);

  const [searchQueryDocs, setSearchQueryDocs] = useState("");

  const search = (data) => {
    console.log("searchQueryDocs : ", searchQueryDocs);
    return data.filter((item) => item.invoiceNo.toLowerCase().includes(searchQueryDocs));
  }

  const ss = useLocation().search;
  const vid = new URLSearchParams(ss).get('vid');

  const fetchDocs = useCallback(async () => {
    // setLoad(true);
    const res = await axios.get(`${appConfig.backendUrl}api/v1/bill/${vid}`);
    console.log("response", res.data);
    // setDocs(sortSuppliers(res.data));
    setDocs(res.data);
    // setLoad(false);
  }, [appConfig.backendUrl, vid]);
  useEffect(() => {
    fetchDocs();
    console.log("test....")
  }, [fetchDocs]);

  // Get current Suppliers
  const indexOfLastDocs = currentPage * docsPerPage;
  const indexOfFirstDocs = indexOfLastDocs - docsPerPage;
  const currentDocs = search(docs).slice(indexOfFirstDocs, indexOfLastDocs);

  // Change page
  const paginate = pageNumber => setCurrentPage(pageNumber);

  const handlePageClick = (data) => {
    paginate(data.selected + 1);
  }

  const totalNoOfPages = Math.ceil(search(docs).length / docsPerPage);

  const DeleteDoc = async (id, vendorId) => {
    console.log(id);
    setLoad(true);
    await axios.patch(`${appConfig.backendUrl}api/v1/bill/deleteDoc/${id}`, null).then(function (response) {
      console.log("Sss");
      console.log(response.data);
      setLoad(false);
      toast.success("Document deleted successfully", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      fetchDocs();
      //  navigate(`/uploadedDocs/supplier?vid=${vendorId}`);
    }).catch(err => {
      setLoad(false);
      toast.error(`${err}`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
  }



  return (
    <div className='pushqb-container'>
      <div className="page-header">
        <h1 className="page-title">
          <FontAwesomeIcon icon={faFileInvoice} />
          {vname ? `Supplier Documents` : 'Supplier Documents'}
        </h1>
        <p className="page-subtitle">View and manage documents from this supplier</p>
      </div>
      {!load && <div className="input-group  btn-radius relative search-wrap"><input type="text" id="searchQueryInput" placeholder="Search" className="search form-control btn-input" onChange={(e) => setSearchQueryDocs(e.target.value)} />
        <span className="faEyeIcon" >
          <FontAwesomeIcon icon={faSearch} />
        </span>
      </div>
      }
      <div className="table-responsive">
        <table className='modern-table'>
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Status</th>
              <th>Supplier Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentDocs.map(doc => (<tr key={doc.id}>
              <td data-label="Document Name" className="id-cell"><Link to={`/uploadedDocs/viewDoc?did=${doc.id}`} >{doc.invoiceNo}</Link></td>
              <td data-label="Status">
                <span className={`status-badge ${doc.publishStatus.toLowerCase()}`}>
                  {doc.publishStatus}
                </span>
              </td>
              <td data-label="Supplier Name">{doc.vendorName}</td>
              <td data-label="Action"><button className='btn-premium danger' onClick={() => DeleteDoc(doc.id, doc.vendorId)}>Delete</button></td>
            </tr>))}
          </tbody>
        </table>
      </div>
      {/* <ul className='list-group mb-4 text-left listUploaded'>
          {currentDocs.map(doc => (
            <li key={doc._id} className='list-group-item'>
              <Link to={`/uploadedDocs/viewDoc?did=${doc._id}`} >{doc.InvoiceNo}</Link>
            </li>
          ))}
        </ul> */}

      {totalNoOfPages >= 1 && !load && <ReactPaginate previousLabel={'◀'} nextLabel={'▶'} breakLabel={'...'} pageCount={totalNoOfPages} marginPagesDisplayed={3}
        pageRangeDisplayed={10} onPageChange={handlePageClick} containerClassName={'pagination'} pageClassName={'page-item'}
        pageLinkClassName={'page-link'} previousClassName={'page-item'} previousLinkClassName={'page-link'} nextClassName={'page-item'} nextLinkClassName={'page-link'}
        breakClassName={'page-item'} breakLinkClassName={'page-link'} activeClassName={'active'} firstLabel={'First'}
        lastLabel={'Last'} />}

      {totalNoOfPages <= 0 && !load && <h5 className='e-msg'>Opps! Nothing to show</h5>}
      <ToastContainer />
    </div>
  );
}

export default DocumentsUp